import session from './session';
const xml2js = require('xml2js');

const CEP_ORIGEM = '95765000';
/*
código do serviço.
04014 SEDEX
04510 PAC
https://www.correios.com.br/a-a-z/pdf/calculador-remoto-de-precos-e-prazos/manual-de-implementacao-do-calculo-remoto-de-precos-e-prazos
*/
let WS_PARAMS = {
  'nCdEmpresa': '',
  'sDsSenha': '',
  'sCepOrigem': CEP_ORIGEM,
  'sCepDestino': '',
  'nVlPeso': '1',
  'nCdFormato': '1',
  'nVlComprimento': '20',
  'nVlAltura': '5',
  'nVlLargura': '15',
  'nVlDiametro': '0',
  'sCdMaoPropria': 'n',
  'nVlValorDeclarado': '0',
  'sCdAvisoRecebimento': 'n',
  'StrRetorno': 'xml',
  'nCdServico': '04510'
};

const config = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
}

export default {
  calcula_frete(pesoTotal='1',CEP='') {
    WS_PARAMS['nVlPeso'] = pesoTotal;
    WS_PARAMS['sCepDestino'] = CEP;
    const formData = new FormData();
    Object.keys(WS_PARAMS).forEach(key => formData.append(key, WS_PARAMS[key]));
    return new Promise(function(resolve, reject) {
      session.post('calculaFrete', formData, config).then(response => {
      var parser = new xml2js.Parser({'attrkey': '@', 'explicitArray': false});
      let res = response.data;
      let retorno = [];
        parser.parseString(res, function (err, xml) {
          if (err) {
            reject(err);
          }
          if ( typeof(xml.cResultado.Servicos.cServico) === 'object' ){
            resolve(xml.cResultado.Servicos.cServico);
          }
        });
      });
    });
    
  },
};
